import { defineStore } from 'pinia';
import {
  setToken,
  setMainListMode,
  setDetailInfoMode,
  setIsFather,
  setIsPicture,
  setIsDialog
} from '@/utils/token';
import commonServices from '@/services/common.services';

export const useUserStore = defineStore('user', {
  state() {
    return {
      /**
       * sfid
       */
      accountId: '',
      /**
       * 电话
       */
      mobile: '',
      /**
       * 姓名
       */
      userName: '',
      /**
       * uid
       */
      uid: '',
      /**
       * 邮箱
       */
      email: '',
      /**
       * 是否是管理员
       */
      isSupperAdmin: false,
      /**
       * 是否是报表管理员
       */
      isShowBack: false,
      /**
       * 是否是外部用户
       */
      isExternalUser: false,
      /**
       * 是否是外部用户管理员
       */
      isExternalAdmin: false
    };
  },
  actions: {
    /**
     * 获取token
     * @param code
     */
    getToken(code) {
      if (process.env.NODE_ENV === 'development') {
        return new Promise(resolve => {
          const token =
            'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoi5a2f54eV6ZyeIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvbmFtZWlkZW50aWZpZXIiOiIyMjA3MTkwMzgiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3VzZXJkYXRhIjoie1wiYWNjb3VudElkXCI6XCIyMjA3MTkwMzhcIixcIm1vYmlsZVwiOlwiMTM1KioqKjUyOTJcIixcInVzZXJOYW1lXCI6XCLlrZ_nh5XpnJ5cIixcInVpZFwiOlwiMjIwNzE5MDM4XCIsXCJlbWFpbFwiOlwibWVuZ3l4MUBjaGludC5jb21cIixcInRva2VuXCI6bnVsbCxcIkNvZGVcIjpbXCJBMTAwMTAwMDFcIixcIkI3MDEwMDYyN1wiLFwiQzcwMjAyNDA1XCJdLFwiSXNTdXBwZXJBZG1pblwiOmZhbHNlLFwiSXNTaG93QmFja1wiOmZhbHNlLFwiSXNFeHRlcm5hbFVzZXJcIjpmYWxzZSxcIklzRXh0ZXJuYWxBZG1pblwiOmZhbHNlfSIsIm5iZiI6MTc0MjgwNjEwOSwiZXhwIjoxNzQyOTE0MTA5LCJpc3MiOiJDaGludEdyb3VwIiwiYXVkIjoiQ2hpbnRDbGllbnQifQ.2PYq-un05TBLz3p-jGrOMT4C1_vh_HuFX4Rl1DAJTwY';
          // 存入cookie
          setToken(token);
          setMainListMode('list');
          setDetailInfoMode('hidden');
          setIsFather('false');
          setIsPicture('false');
          setIsDialog('false');
          resolve(token);
        });
      }
      return new Promise((resolve, reject) => {
        commonServices
          .ssoLogin(code)
          .then(res => {
            const token = res.data?.token;
            // 存入cookie
            setToken(token);
            setMainListMode('list');
            setDetailInfoMode('hidden');
            setIsFather('false');
            setIsPicture('false');
            setIsDialog('false');
            resolve(token);
          })
          .catch(err => reject(err));
      });
    },
    /**
     * 获取基本数据
     */
    getSetup() {
      return new Promise((resolve, reject) => {
        commonServices
          .getCurrentUser()
          .then(res => {
            const data = res.data;
            this.$patch({ ...data });
            resolve(data);
          })
          .catch(err => reject(err));
      });
    }
  }
});
